import { InjectionToken } from "@angular/core";
import { IReceiversOverviewStateService } from "./i-receivers-overview-state.service";

export const receiversOverviewStateServiceInjectionToken: InjectionToken<IReceiversOverviewStateService> = new InjectionToken<IReceiversOverviewStateService>("digital-signage.user-dashboard.dashboard-web.ReceiversOverviewStateService")
